var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { useFormContext } from "react-hook-form";
import { ModalHeader, SlideInModalPortal, } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { INCOME_CAPTURE_VIEWS, useIncomeCaptureContext, } from "../../../context/incomeCaptureContext";
import getTranslation from "../../../strings/getTranslations";
import ErrorBoundary from "../ErrorBoundary";
import IncomeCaptureError from "../IncomeCaptureError";
import IncomeCaptureSuccess from "../IncomeCaptureSuccess";
import IncomeCaptureModalContent from "./IncomeCaptureModalContent";
import FakeOverlay from "./subComponents";
import { IncomeCaptureModalFooter } from "./IncomeCaptureModalFooter";
export var incomeCaptureModalId = "income-capture-modal";
var IncomeCaptureModal = function (_a) {
    var containerId = _a.containerId;
    var headerRef = useRef(null);
    var _b = useIncomeCaptureContext(), _c = _b.state, isModalOpen = _c.isModalOpen, isMutationLoading = _c.isMutationLoading, view = _c.view, handleClose = _b.handleClose, dispatch = _b.dispatch;
    var handleSubmit = useFormContext().handleSubmit;
    var t = getTranslation().t;
    var shouldRenderIncomeCaptureModalContent = isModalOpen; // && accountId && accountSummary;
    var handleCloseFunction = function () {
        if (!isMutationLoading) {
            handleClose();
        }
    };
    var onSubmit = function () {
        dispatch({ view: INCOME_CAPTURE_VIEWS.SUCCESS });
    };
    return (_jsxs(_Fragment, { children: [_jsx(SlideInModalPortal, __assign({ id: incomeCaptureModalId, containerId: containerId, isOpen: isModalOpen, ariaLabel: t("incomeCapture.modal.header.text"), escapeModalHandler: handleCloseFunction, header: _jsx(ModalHeader, { headerRef: headerRef, hideClose: true, closeModal: handleCloseFunction, content: t("incomeCapture.modal.header.text") }), footer: _jsx(IncomeCaptureModalFooter, {}) }, { children: shouldRenderIncomeCaptureModalContent && (_jsx(ErrorBoundary, __assign({ fallbackComponent: _jsx(IncomeCaptureError, {}) }, { children: view === INCOME_CAPTURE_VIEWS.SUCCESS ? (_jsx(IncomeCaptureSuccess, {})) : (_jsx("form", __assign({ onSubmit: handleSubmit(onSubmit), id: "income-capture-form" }, { children: _jsx(IncomeCaptureModalContent, {}) }))) }))) })), isModalOpen && (_jsx(FakeOverlay, { id: "fake-overlay", onClick: handleCloseFunction, "data-type": "income-capture", "data-reason": "close", "data-analytics": "clicktrackingevent", "aria-hidden": "true" }))] }));
};
export default IncomeCaptureModal;
